"use strict";
/**
 * Created on 07 07 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../../core/conversions/DataObjectConverter");
/**
 * <p>Serialization/deserialization of {@link SelloutTerminationUpload}.</p>
 *
 * @author JMe
 */


var SelloutTerminationUploadConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutTerminationUploadConverter, _DataObjectConverter_);

  function SelloutTerminationUploadConverter() {
    _classCallCheck(this, SelloutTerminationUploadConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutTerminationUploadConverter).apply(this, arguments));
  }

  return SelloutTerminationUploadConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutTerminationUploadConverter = SelloutTerminationUploadConverter;